/**
 * @prettier
 * @flow
 */
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import * as React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { translate } from 'src/utils/translate/translate';

export function FormAddressCityField({ name, label, placeholder, helperText, value, onChange, variant = 'outlined', required, disabled, InputProps, rules, defaultValue = '' }: Props) {
    const classes = useStyles();

    const {
        errors,
        control,
        formState: { isSubmitting },
    } = useFormContext();

    const maxLength = 100;

    return (
        <Controller
            as={TextField}
            name={`${name}.city`}
            label={label}
            placeholder={translate('City')}
            // helperText={errors[name]?.['city']?.message ?? helperText}
            rules={{
                required: {
                    value: rules?.required,
                    message: translate('This field is required'),
                },
                maxLength: {
                    value: maxLength,
                    message: translate('Must be at most @number characters', { number: maxLength }),
                },
            }}
            error={!!errors[name]?.['city']}
            InputProps={InputProps}
            InputLabelProps={{ shrink: placeholder ? true : undefined }}
            value={value}
            onChange={onChange}
            variant={variant}
            required={required}
            disabled={isSubmitting || disabled}
            fullWidth
            control={control}
            defaultValue={defaultValue}
            classes={{ root: classes.input }}
        />
    );
}

const useStyles = makeStyles(theme => ({
    input: {
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderTopColor: 'white',
                borderLeftColor: 'white',
                borderRadius: 0,
            },
            '&:hover fieldset': {
                // borderBottomColor: 'white',
            },
            '&.Mui-focused fieldset': {
                // borderBottomColor: 'white',
            },
        },
    },
}));

export type Props = {|
    name: string,
    label?: string,
    placeholder?: string,
    helperText?: string,
    value?: string,
    onChange?: string,
    variant?: 'filled' | 'outlined' | 'standard',
    required?: boolean,
    disabled?: boolean,
    rules?: {|
        required?: boolean,
        email?: boolean,
        min?: number | { message: string, value: number },
        max?: number | { message: string, value: number },
        minLength?: number | { message: string, value: number },
        maxLength?: number | { message: string, value: number },
    |},
    InputProps?: any,
    defaultValue?: string,
|};
